import Vue from 'vue';
import Button from '../components/Button/index.vue';
import Input from '../components/Input/index.vue';
Vue.component('ElButton', Button);
Vue.component('ElInput', Input);
Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 };
